import PropTypes from 'prop-types';

export const LogicalClaimHistoryPropTypes = {
  TransactionDate: PropTypes.string,
  StatusCode: PropTypes.string,
  Status: PropTypes.string,
  SubStatus: PropTypes.string
};

export const LogicalClaimPropTypes = {
  LogicalClaimNumber: PropTypes.string,
  Status: PropTypes.string,
  SubStatus: PropTypes.string,
  StatusCode: PropTypes.string,
  BenefitPaid: PropTypes.number,
  ClaimedAmount: PropTypes.number,
  MethodOfReimbursement: PropTypes.string,
  LogicalClaimDescription: PropTypes.string,
  LogicalClaimStatusType: PropTypes.string,
  LogicalClaimStatus: PropTypes.string,
  LogicalClaimSubStatus: PropTypes.string,
  PaymentDate: PropTypes.string,
  ClaimDetailsDocuments: PropTypes.string,
  LogicalClaimNotes: PropTypes.string,
  LogicalClaimHistory: PropTypes.arrayOf(PropTypes.shape(LogicalClaimHistoryPropTypes)),
  PaidTo: PropTypes.string
};

export const ClaimDetailPropTypes = {
  ClaimTypeCode: PropTypes.string,
  ClaimTypeDescription: PropTypes.string,
  ReceivedDate: PropTypes.string,
  PolicyNumber: PropTypes.string,
  ClaimNumber: PropTypes.string,
  FullClaimNumber: PropTypes.string,
  Status: PropTypes.string,
  PetName: PropTypes.string,
  ClaimRefNumber: PropTypes.string,
  Source: PropTypes.string,
  StatusCode: PropTypes.string,
  SubStatus: PropTypes.string,
  PetPhoto: PropTypes.string,
  ServiceProviderName: PropTypes.string,
  ClaimDescription: PropTypes.string,
  IsNonLEC: PropTypes.bool,
  IsNonLECBrand: PropTypes.bool,
  LogicalClaims: PropTypes.arrayOf(PropTypes.shape(LogicalClaimPropTypes)),
  UploadAdditionalDocs: PropTypes.bool,
  ClaimDetailsDocuments: PropTypes.string
};

export const SavedClaimPropTypes = {
  CustomerClaimId: PropTypes.number,
  CustomerId: PropTypes.string,
  ClaimPolicyNumber: PropTypes.string,
  ClaimDescription: PropTypes.string,
  Status: PropTypes.string,
  SubStatus: PropTypes.string,
  PartnerNumber: PropTypes.string,
  Created: PropTypes.string,
  Modified: PropTypes.string,
  ProfilePhotoDocid: PropTypes.string,
  ProfilePhotoDocPath: PropTypes.string,
  BGImageDocPath: PropTypes.string,
  BGImageDocid: PropTypes.string,
  PetName: PropTypes.string,
  BGImageUrl: PropTypes.string,
  ProfileImageUrl: PropTypes.string,
  PetSpecies: PropTypes.oneOf(['Canine', 'Feline'])
};

export const UploadedFilePropTypes = {
  ClaimFileId: PropTypes.number.isRequired,
  CustomerClaimId: PropTypes.number.isRequired,
  FileName: PropTypes.string.isRequired,
  FileSize: PropTypes.number,
  DocumentId: PropTypes.string.isRequired,
  DocumentPath: PropTypes.string.isRequired,
  DownloadAttachmentURL: PropTypes.string.isRequired
};
